export default class CreativeContent {
  /* content type */
  _contentType;
  /* media type of content */
  _mediaType;

  /**
   * @param {string} contentType
   * @param {string} mediaType
   */
  constructor(contentType, mediaType) {
    this._contentType = contentType;
    this._mediaType = mediaType;
  }

  copy() {
    return new CreativeContent(this.contentType, this.mediaType);
  }

  get contentType() {
    return this._contentType;
  }

  get mediaType() {
    return this._mediaType;
  }

  /**
   * Checks if object is an instance of CreativeContent
   *
   * @param inputObject
   * @returns {boolean}
   */
  static isCreativeContent(inputObject) {
    return (
      inputObject instanceof CreativeContent ||
      (inputObject && inputObject.prototype instanceof CreativeContent)
    );
  }
}
